// shared-sessions-store.svelte.ts — module-level reactive store for the sidebar
// "Shared with me" section (GET /sessions/shared-with-me). Kept separate from
// sessions-store so the two lists refresh independently and the user's own
// time-bucketed chats never co-mingle with chats others shared with them.

import { getSharedWithMe, type SharedSessionView } from './session-share-api.ts';

const shared = $state<SharedSessionView[]>([]);
let loaded = $state(false);

export function getSharedSessions(): SharedSessionView[] {
	return shared;
}

export function sharedLoaded(): boolean {
	return loaded;
}

export async function refreshSharedSessions(): Promise<void> {
	try {
		const next = await getSharedWithMe();
		shared.length = 0;
		shared.push(...next);
	} catch (err) {
		// Non-fatal: the sidebar section just stays empty/last-known. A failed
		// fetch here must never block the user's own chat list from rendering.
		console.warn('[shared-sessions] refresh failed', err);
	} finally {
		loaded = true;
	}
}
